import { Box, List, ListItem, ListProps } from "@mui/material";
import { VehicleAssessment } from "../../system/Domain";
import formatCurrency from "system/formatCurrency";
import Text from "Pages/VehicleSales/Text";
import { containsAny } from "utils";

interface Props extends ListProps {
	assessment: VehicleAssessment
}

const RemarketingAssessmentDamages = (props: Props) => {
	return (
		<List sx={{ fontSize: "0.7rem", paddingBottom: 0 }}>
			{props.assessment.damages?.map(d => (
				<ListItem key={d.text}>
					<Box>
						<Text
							value={d.text}
							color={containsAny(d.text, ['Windschutzscheibe', 'Frontscheibe', 'WSS', 'Glasschaden', 'Glas']) ? "warning" : null}
						/>
						<Text
							value={formatCurrency(d.amount)}
						/>
					</Box>
				</ListItem>
			))}
			{props.assessment.damages?.length === 0 && (
				<ListItem>Keine Daten gefunden oder noch nicht geladen</ListItem>
			)}
		</List>
	)
};

export default RemarketingAssessmentDamages;
